import { useEffect, useState } from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useApi } from "@/lib/api";
import { CRM_GROUPS, CRM_TABS } from "./tabs";

// Modules the client actually uses (configured or with data): operations tabs appear only then.
export function useCrmTabs(tid, role) {
  const api = useApi();
  const [mods, setMods] = useState(null);
  useEffect(() => { setMods(null); api.get(`/t/${tid}/crm/modules`).then(({ data }) => setMods(data)).catch(() => setMods({})); }, [api, tid]);
  return CRM_TABS.filter((x) => (!x[3] || x[3].includes(role)) && (!x[4] || mods?.[x[4]]));
}

// One CRM, grouped navigation: each group is a labelled cluster of tabs, all reachable in one click (wraps on small screens).
export default function CrmNav({ tabs, prefix = "crm", groups = CRM_GROUPS }) {
  const keys = new Set(tabs.map((t) => t[0]));
  return (
    <TabsList className="flex h-auto w-full flex-wrap items-stretch justify-start gap-x-4 gap-y-2 bg-transparent p-0" data-testid={`${prefix}-tabs`}>
      {groups.map(([label, ks]) => ks.some((k) => keys.has(k)) && (
        <div key={label} role="group" aria-label={label} className="flex flex-col gap-1 rounded-lg border border-slate-200 bg-slate-50 p-1" data-testid={`${prefix}-group-${ks[0]}`}>
          <span className="px-2 pt-0.5 text-[10px] font-semibold uppercase tracking-wider text-slate-400">{label}</span>
          <div className="flex flex-wrap gap-0.5">{tabs.filter((t) => ks.includes(t[0])).map(([k, l]) => (
            <TabsTrigger key={k} value={k} className="min-h-10 px-3 py-2 text-xs sm:min-h-0 sm:px-2.5 sm:py-1 data-[state=active]:bg-white data-[state=active]:shadow-sm" data-testid={`${prefix}-tab-${k}`}>{l}</TabsTrigger>))}</div>
        </div>))}
    </TabsList>);
}
